module.exports = __webpack_public_path__ + "img/notice1.fea0bc5d.png";